export default __webpack_public_path__ + "static/media/doc.94aa6a08.svg";